export const VitrinsCreditCardsFiltersFormTexts = {
  LimitInputLabel: 'Кредитный лимит',
  ButtonLabel: 'Показать',
};
